/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Unavailable_LegacyInputs */

const en_plan_change_unavailable_legacy = /** @type {(inputs: Plan_Change_Unavailable_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This plan can't be changed here. Contact support.`)
};

const es_plan_change_unavailable_legacy = /** @type {(inputs: Plan_Change_Unavailable_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plan no se puede cambiar aquí. Contacta con soporte.`)
};

/**
* | output |
* | --- |
* | "This plan can't be changed here. Contact support." |
*
* @param {Plan_Change_Unavailable_LegacyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_unavailable_legacy = /** @type {((inputs?: Plan_Change_Unavailable_LegacyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Unavailable_LegacyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_unavailable_legacy(inputs)
	return en_plan_change_unavailable_legacy(inputs)
});